import type { CasinoRace } from '@ps/web-casino-types';

import { casinoRace } from '../entities';

export const raceEntity = ({ id, name, numOfPlayers, status }: CasinoRace) =>
  casinoRace({
    numberOfPlayers: numOfPlayers,
    raceId: id,
    raceName: name,
    raceStatus: status
  });
